import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateLocalModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/locais',
    nameForTitle: 'Local',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateLocalModal
